@let firstName = applicationStore.userFirstName();
@let lastName = applicationStore.userLastName();
@let email = applicationStore.userEmail();
@let emailVerified = applicationStore.userEmailVerified();
@let userPermissions = applicationStore.userPermissions();

<app-component-card [title]="'app.label.personal.information' | translate">
  <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
    <div>
      <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            {{ 'app.label.first.name' | translate }}
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ firstName }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            {{ 'app.label.last.name' | translate }}
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ lastName }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            {{ 'app.label.email.address' | translate }}
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ email }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400 h-4">
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            <app-checkbox
              [checked]="emailVerified" [disabled]="true"
              [label]="'app.label.email.verified' | translate"
            />
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            {{ 'app.label.roles' | translate }}
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ userPermissions.join(', ') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</app-component-card>
